function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconBlogcast = props => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "Ebene 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 29.061 29.971"
}, props), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  },
  d: "M1 9v11.971M7.765 1v27.971M14.53 4v21.971M28.061 20.971V9M21.295 28.971V1"
}));
export default SvgIconBlogcast;